var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6775 24C23.4133 24 24 23.404 24 22.6775V1.32247C24 0.586729 23.404 0 22.6775 0H1.32247C0.596042 0 0 0.596042 0 1.32247V22.6775C0 23.4133 0.596042 24 1.32247 24H22.6775Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5591 24V14.7055H19.679L20.1447 11.0826H16.5591V8.77298C16.5591 7.72059 16.8478 7.01279 18.3565 7.01279H20.2751V3.7625C19.9398 3.71593 18.8036 3.6228 17.4811 3.6228C14.7151 3.6228 12.8245 5.30848 12.8245 8.40976V11.0826H9.69531V14.7055H12.8245V24H16.5591Z",
    fill: "#3B5998"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookLogo);
export default __webpack_public_path__ + "static/media/ic_facebook-logo.f2ae12c1.svg";
export { ForwardRef as ReactComponent };